import { Link } from 'wouter-preact'
import { clsx } from 'clsx'

import { Typography } from '../typography'

type TextVariants = 'primary' | 'secondary'
type Sizes = 'normal' | 'small'

type Props = {
	ariaLabel: string
	className?: string
	disabled?: boolean
	href?: string
	hrefNewTab?: string
	isLoading?: boolean
	onClick?: () => void
	size?: Sizes
	text: string
	textColor?: string
	variant?: TextVariants
}

const styles = {
	textColors: {
		primary:
			'cursor-pointer text-product hover:text-product-hover active:text-product-active disabled:text-black-400',
		secondary:
			'cursor-pointer text-black-100 hover:text-black-200 active:text-black-400 disabled:text-black-400',
		disabled: 'text-black-400'
	}
}

const TextLink = ({
	ariaLabel,
	className,
	disabled = false,
	href,
	hrefNewTab,
	isLoading = false,
	onClick,
	size = 'normal',
	text,
	textColor,
	variant = 'primary'
}: Props) => {
	const textVariant = size === 'normal' ? 'text2' : 'text3'
	const typographyStyles = disabled
		? styles.textColors.disabled
		: clsx(styles.textColors[variant], textColor)

	if (hrefNewTab) {
		return (
			<a
				aria-label={ariaLabel}
				class={clsx('focus:outline-transparent', className)}
				href={hrefNewTab}
				rel='noreferrer'
				target='_blank'
			>
				<Typography
					class='underline'
					color={typographyStyles}
					text={text}
					variant={textVariant}
				/>
			</a>
		)
	}

	if (href && !disabled) {
		return (
			<Link class={className} href={href}>
				<Typography
					class='underline'
					color={typographyStyles}
					text={text}
					variant={textVariant}
				/>
			</Link>
		)
	}

	return (
		<button
			aria-busy={isLoading}
			aria-label={ariaLabel}
			class={clsx('focus:outline-transparent', className)}
			disabled={disabled}
			onClick={onClick}
			type='button'
		>
			<Typography
				class='underline'
				color={typographyStyles}
				text={text}
				variant={textVariant}
				weight='font-medium'
			/>
		</button>
	)
}

export { TextLink }
